export enum ControllerExtensionModel {
  VR70 = 'VR70',
  VR71 = 'VR71'
}
